import React, { useState, useEffect } from 'react';
import Giveaway from '../../assets/images/giveaway.png'
import JoinBetaButton from './JoinBetaButton';
import { Link } from 'react-router-dom';
import { Leaderboard } from './Leaderboard';

const Banner = ({ metrics }) => {
    const [currentTime, setCurrentTime] = useState(() => {
        const counterTarget = new Date('2025-08-01 12:00').getTime();
        const difference = counterTarget - new Date().getTime();
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);
        return {
            days,
            hours,
            minutes,
            seconds
        }
    });
    const calculateTime = (seconds) => {
        const days = Math.floor(seconds / (3600 * 24));
        const hours = Math.floor((seconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsLeft = seconds % 60;
        return { days, hours, minutes, seconds: secondsLeft };
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime((prev) => {
                const totalSeconds =
                    prev.days * 86400 + prev.hours * 3600 + prev.minutes * 60 + prev.seconds;
                return totalSeconds > 0 ? calculateTime(totalSeconds - 1) : prev;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    const formatNumber = (num) => num.toString().padStart(2, '0');

    return (
        <div id='home' className="banner-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="banner-content">
                            <h1 className='right-reveal'>The First Zero Trust <br /> Poker Platform</h1>
                            <p className='right-reveal'>Revolutionary next-generation P2P encryption and smart contract-based fund management ensure complete transparency and fairness in online poker.</p>
                            <div className="right-reveal d-flex gap-3 justify-content-center justify-content-lg-start">
                                <JoinBetaButton />
                                <Link to="/whitepaper.pdf" target='_blank' rel="noopener noreferrer" className='btn btn-border'>Whitepaper</Link>
                            </div>
                            <div className="right-reveal users-tokents">
                                <div className="user-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                        <g clip-path="url(#clip0_1_42)">
                                            <path d="M9.5 4C9.5 3.33696 9.23661 2.70107 8.76777 2.23223C8.29893 1.76339 7.66304 1.5 7 1.5C6.33696 1.5 5.70107 1.76339 5.23223 2.23223C4.76339 2.70107 4.5 3.33696 4.5 4C4.5 4.66304 4.76339 5.29893 5.23223 5.76777C5.70107 6.23661 6.33696 6.5 7 6.5C7.66304 6.5 8.29893 6.23661 8.76777 5.76777C9.23661 5.29893 9.5 4.66304 9.5 4ZM3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4ZM1.54062 14.5H12.4594C12.1813 12.5219 10.4813 11 8.42813 11H5.57188C3.51875 11 1.81875 12.5219 1.54062 14.5ZM0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5H8.42813C11.5063 9.5 14 11.9937 14 15.0719C14 15.5844 13.5844 16 13.0719 16H0.928125C0.415625 16 0 15.5844 0 15.0719Z" fill="#3B82F6" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1_42">
                                                <path d="M0 0H14V16H0V0Z" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="text">
                                        <p>Beta Users</p>
                                        <h6>{metrics?.totalPlayers || 0}</h6>
                                    </div>
                                </div>
                                <div className="user-item">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                        <g clip-path="url(#clip0_1_49)">
                                            <path d="M6.20312 2.15L7.29063 4H7.25H5C4.30937 4 3.75 3.44062 3.75 2.75C3.75 2.05938 4.30937 1.5 5 1.5H5.06875C5.53437 1.5 5.96875 1.74688 6.20312 2.15ZM2.25 2.75C2.25 3.2 2.35938 3.625 2.55 4H1.25C0.696875 4 0.25 4.44688 0.25 5V7C0.25 7.55312 0.696875 8 1.25 8H15.25C15.8031 8 16.25 7.55312 16.25 7V5C16.25 4.44688 15.8031 4 15.25 4H13.95C14.1406 3.625 14.25 3.2 14.25 2.75C14.25 1.23125 13.0188 0 11.5 0H11.4312C10.4344 0 9.50938 0.528125 9.00313 1.3875L8.25 2.67188L7.49687 1.39062C6.99062 0.528125 6.06562 0 5.06875 0H5C3.48125 0 2.25 1.23125 2.25 2.75ZM12.75 2.75C12.75 3.44062 12.1906 4 11.5 4H9.25H9.20938L10.2969 2.15C10.5344 1.74688 10.9656 1.5 11.4312 1.5H11.5C12.1906 1.5 12.75 2.05938 12.75 2.75ZM1.25 9V14.5C1.25 15.3281 1.92188 16 2.75 16H7.25V9H1.25ZM9.25 16H13.75C14.5781 16 15.25 15.3281 15.25 14.5V9H9.25V16Z" fill="#3B82F6" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1_49">
                                                <path d="M0.25 0H16.25V16H0.25V0Z" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <div className="text">
                                        <p>Tokens Airdropped</p>
                                        <h6>{metrics?.tokenAirdrop || 0}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className='countdown-container'>
                                <div className="countdown bottom-reveal">
                                    <h4>Token Fair Launch Countdown</h4>
                                    <div className='time-count'>
                                        <div className="time-item">
                                            <span>{formatNumber(currentTime.days)}</span>
                                            <p>Days</p>
                                        </div>
                                        <div className="time-item">
                                            <span>{formatNumber(currentTime.hours)}</span>
                                            <p>Hours</p>
                                        </div>
                                        <div className="time-item">
                                            <span>{formatNumber(currentTime.minutes)}</span>
                                            <p>Minutes</p>
                                        </div>
                                        <div className="time-item">
                                            <span>{formatNumber(currentTime.seconds)}</span>
                                            <p>Seconds</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='dont-miss'>Join our Beta, get your 100 Tokens airdrop and start playing instantly</div>
                        </div>
                    </div>
                    <div style={{ marginTop: "20px" }} className="giveaway-content top-reveal show-mobile">
                        <img src={Giveaway} alt="Giveaway" />
                    </div>
                    <div className="col-lg-6" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                        <div className="giveaway-content top-reveal hide-mobile">
                            <img src={Giveaway} alt="Giveaway" />
                        </div>
                        <Leaderboard />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner